import Router from 'vue-router'
Vue.use(Router)
const Empty = {
    template: '<div></div>'
}
const routes = [
    {
        name: 'model',
        path: '/model/:id', props: true, component: function (resolve) {
            require(['./components/Detail.vue'], resolve)
        },
    },
    {
        name: 'favorite',
        path: '/favorite/:id', props: true, component: function (resolve) {
            require(['./components/Detail.vue'], resolve)
        },

    }
    // {
    //     name: 'modelFavorite',
    //     path: ':listName/model/:id', props: true, component: function (resolve) {
    //         require(['./components/Detail.vue'], resolve)
    //     },
    // }
]


const router = new Router({
    mode: 'history',
    routes,
})
export default router
